import request from '@/utils/request'
import { detectiveUrl } from '@/env'

export function getCategory(state) {
    return request({
        url: `${detectiveUrl()}/api/category/${state}`,
        method: 'get'
    })
}
